module.exports = __webpack_public_path__ + "img/1.456b035.png";